const QuizEmailForm = ({
  emailFormTitle,
  emailFormSubtitle,
  firstNamePlaceholder,
  emailPlaceholder,
  phonePlaceholder,
  consentText,
  submitButtonLabel,
  formData,
  onFormChange,
  onSubmit,
  isSubmitting
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <div className="flex min-h-[500px] flex-col items-center">
      <div className="flex flex-1 flex-col items-center justify-center">
        {emailFormTitle && (
          <div className="text-brand-400 mb-3 text-[20px] leading-normal font-medium">{emailFormTitle}</div>
        )}
        {emailFormSubtitle && (
          <div className="mb-10 text-center text-[16px] leading-normal font-medium text-white">{emailFormSubtitle}</div>
        )}

        <form onSubmit={handleSubmit} className="flex w-full flex-col gap-4">
          <input
            type="text"
            name="firstName"
            autoComplete="given-name"
            className="h-[52px] w-full rounded-[26px] bg-white px-10 text-center text-[16px] text-black outline-none placeholder:text-black/50 placeholder:italic"
            placeholder={firstNamePlaceholder}
            value={formData.firstName}
            onChange={(e) => onFormChange({ ...formData, firstName: e.target.value })}
          />
          <input
            type="email"
            name="email"
            autoComplete="email"
            className="h-[52px] w-full rounded-[26px] bg-white px-10 text-center text-[16px] text-black outline-none placeholder:text-black/50 placeholder:italic"
            placeholder={emailPlaceholder}
            value={formData.email}
            onChange={(e) => onFormChange({ ...formData, email: e.target.value })}
            required
          />
          <input
            type="tel"
            name="phone"
            autoComplete="tel"
            className="h-[52px] w-full rounded-[26px] bg-white px-10 text-center text-[16px] text-black outline-none placeholder:text-black/50 placeholder:italic"
            placeholder={phonePlaceholder || 'Váš telefon'}
            value={formData.phone}
            onChange={(e) => onFormChange({ ...formData, phone: e.target.value })}
          />

          {consentText && (
            <div className="text-center text-[13px] leading-normal font-medium text-white">{consentText}</div>
          )}

          <div className="mt-4 flex justify-center">
            <button
              type="submit"
              disabled={isSubmitting || !formData.email}
              className="hover:text-brand-400 hover:border-brand-400 cursor-pointer rounded-[60px] border-3 border-white bg-transparent px-10 py-4 text-[16px] font-medium text-white transition-colors duration-300 ease-in-out disabled:pointer-events-none disabled:opacity-50"
            >
              {isSubmitting ? '...' : submitButtonLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default QuizEmailForm;
